module.exports = __webpack_public_path__ + "img/avans-paid.2b26b652.svg";